<template>
<div id="listen" >
    <div v-if="unit != null" id="unit" v-loading.fullscreen.lock="fullscreenLoading" style="position:absolute;top:0px;left:0px;width:100%;height:100%;background: white url(/images/mode/bg.png) repeat fixed top;">
        <div class="ebookHeader">
            <div style="margin-top:10px;"><a href="#" @click="backToIndex" class="backBtn backBtn-eBook">Back</a></div>
        </div>
        <div v-if="unit.audio" style="margin: 10px auto;;" :style="{width :audioWidth +'px'}">
            <audio style="width:100%;"  :src="unit.audio" controls></audio>
        </div>
        <div v-if= "pictures != null && pictures.length > 0" style="text-align:center;">
            <img :src="pictures[index]" :height="unitImageHeight" style="transform:scale(1.0);" />
            <div style="position:absolute;left:50px;bottom:50px;">
                <img v-if="index != 0" src="/images/listen/last.png" @click="last" />
            </div>
            <div style="position:absolute;right:50px;bottom:50px;">
                <img v-if="index != pictures.length-1" src="/images/listen/next.png"  @click="next"/>
            </div>
        </div>
        <el-card v-else-if="unit.tx" style="margin:auto auto;overflow: auto;" :style="{height : unitImageHeight+'px',width :audioWidth +'px'}">
            <div style="font-family: 'Times New Roman', Times, serif; font-size: 23px;" v-html="unit.tx">
            </div>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    name : 'listen',
    data(){
        return {
            audioWidth : document.documentElement.clientWidth*0.5,
            unitImageHeight : document.documentElement.clientHeight * 0.8,
            unit : null,
            fullscreenLoading : false,
            pictures : null,
            index : 0
        }
    },
    methods : {
        backToIndex : function(){
            this.$router.go(-1);
        },
        next : function(){
            this.index++;
        },
        last : function(){
            this.index--;
        }
    },
    mounted : function(){
        let _this = this;
        if(_this.$route.params.unit){
            _this.unit = _this.$route.params.unit;
            localStorage.setItem("unit",JSON.stringify(_this.unit));
        }else{
            if(localStorage.getItem("unit")){
                _this.unit = JSON.parse(localStorage.getItem("unit"));
            }else{
                _this.$router.go(-1);
            }
        }
        _this.request("GET","/unit/"+_this.unit.id+"/detail",null,function(data){
            _this.unit.tx = data.tx;
            _this.unit.pictures = data.pictures;
            _this.unit.audio = data.audio;
            _this.pictures = JSON.parse(_this.unit.pictures);
            _this.unit.tx = _this.unit.tx.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ');
        });
    },
}
</script>

<style>
div img:hover{  
    transform: scale(1.05);  
} 
</style>